import { render, staticRenderFns } from "./billing-record-list.vue?vue&type=template&id=93486c8c&"
import script from "./billing-record-list.vue?vue&type=script&lang=js&"
export * from "./billing-record-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports